import { useLogisticFilters } from 'hooks/useLogisticFilters'
import { logisticApi } from 'redux/services/logistic'

import { AppStatistics } from 'components/AppStatistics/AppStatistics'

export function Statistics() {
  const { params } = useLogisticFilters()

  const { data, isSuccess } = logisticApi.useLogisticStatisticsQuery({
    ...params,
    path_name: 'applications_branches',
  })

  if (isSuccess) {
    return <AppStatistics list={data} />
  }
  return null
}
